module.exports = __webpack_public_path__ + "static/4-eefab8449cda64efbe5beeac9b822eac.jpg";